var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"gen-fond"},[_c('div',{staticClass:"w-full max-w-[355px] tablet:max-w-2xl text-lg tablet:text-2xl text-white text-center m-auto mt-8"},[_c('img',{staticClass:"w-[250px] tablet:w-[300px] m-auto",attrs:{"src":require("@/assets/images/logo.png")}}),_c('h1',[_vm._v("Le jeu est n'as pas encore commencé")])])])
}]

export { render, staticRenderFns }